import {
  formatDateParam,
  makeRequest,
  makeConcurrentRequest,
} from "../lib/makeRequest";
import moment from "moment";

export const inventory_details_overall = (data) =>
  makeRequest("/inventory-details/overall", {
    covered_date: formatDateParam(data.covered_date),
  });

export const inventory_details_cluster = (data) =>
  makeRequest(`/inventory-details/cluster/${data.clusterId}`, {
    covered_date: formatDateParam(data.covered_date),
  });

export const inventory_details_area = (data) =>
  makeRequest(`/inventory-details/area/${data.area_code}`, {
    covered_date: formatDateParam(data.covered_date),
  });

export const inventory_details_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append(
    "covered_date",
    moment(data.covered_date).format("YYYY-MM-DD")
  );
  return makeRequest(
    `/inventory-details/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};

export const inventory_details_branch_concurrent_request = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("covered_date", formatDateParam(data.covered_date));

  const requestData = data.branchCodechunks.map((chunk) => {
    return {
      endpoint: `/inventory-details/branches?${urlParams.toString()}`,
      params: chunk,
    };
  });

  return makeConcurrentRequest(requestData, "post");
};
